import React, { useContext, useEffect, useRef, useState } from "react";
import { Form, Formik, FormikHelpers, useFormikContext } from "formik";
import * as Yup from "yup";
import { ERRORS, ONBOARDING_STEPS, VIEWS } from "../constants/user-info.const";
import { AppContext } from "../routing/Routing";
import { useNavigate } from "react-router-dom";
import { AddressInfoFormFields } from "./models/user-interface";
import HomeAddressForm from "./user-forms/HomeAddressForm";
import {
  getEmployee,
  updateEmpAddress,
} from "../../services/employeeService";
import { connect } from "react-redux";
import { setEmployeeDetails, UPDATE_EMPLOYEE_ADDRESS } from "../../store/actions/employee";
import Loader from "../common/Loader";
import { onboardingActions } from "../../store/actions/steps";
import { formSubmitErrorHandler } from "../../services/formService";
import store from "../../store";

function HomeAddress(props) {
  const { setViewName } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowFooterLoader, setIsShowFooterLoader] = useState(false);
  const navigate = useNavigate();
  const mountedRef = useRef(true);
  const {
    employee: { home_address },
    setEmployeeData,
    usStates,
    isNavigateToNext
  } = props;

  const navigateToFedaralTax = () => {
    if(isNavigateToNext === false) return;
    setViewName(VIEWS.federalTaxes);
    navigate("/" + VIEWS.federalTaxes);
  };
  useEffect(() => {
    return () => { 
      mountedRef.current = false;
    }
  }, [])
  useEffect(() => {
    setIsLoading(true);
    getEmployee()
      .then((response: any) => {
        if (!mountedRef.current) return null;
        setEmployeeData(response?.data);
        setIsLoading(false);
      })
      .catch(() => {
        if (!mountedRef.current) return null;
        setIsLoading(false);
      });
  }, []);
  const updateCompletedStep = () =>{
    store.dispatch({
      type: onboardingActions.UPDATE_ONBOARDING_STEPS,
      state: ONBOARDING_STEPS.homeAddress
    })
  }
  const validationSchema = Yup.object({
    street_1: Yup.string().required(ERRORS.street),
    street_2: Yup.string(),
    city: Yup.string().required(ERRORS.city),
    state: Yup.object().required(ERRORS.state).nullable(),
    zip: Yup.string().required(ERRORS.zipCode),
  });
  const updateHomeAddressInStore = (data : AddressInfoFormFields) =>{
    store.dispatch({
      type: UPDATE_EMPLOYEE_ADDRESS,
      state: data
    })
  }
  const onSubmit = (
    { street_1, street_2, city, state, zip }: AddressInfoFormFields,
    formHelpers: FormikHelpers<any>
  ) => {
    const data = {
      version: home_address?.version,
      street_1,
      street_2,
      city,
      state: state.id,
      zip: zip,
    };
    setIsShowFooterLoader(true);
    formSubmitErrorHandler(
      updateEmpAddress(data).then((response: any) => {
        setIsShowFooterLoader(false);
        navigateToFedaralTax();
        updateCompletedStep();
        updateHomeAddressInStore(response?.data);
        formHelpers.resetForm();
      }),
      () => {
        setIsShowFooterLoader(false);
      },
      formHelpers.setFieldError
    );
  };

  return (
    <div className="home-address user-details__content">
      <Formik
        initialValues={{
          street_1: home_address?.street_1 || "",
          street_2: home_address?.street_2 || "",
          city: home_address?.city || "",
          state: usStates?.find((v) => v.id === home_address?.state) ?? {},
          zip: home_address?.zip || "",
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
        innerRef={props.formRef}
      >
        {() => {
          return (
            <Form>
              <div className="user-details--section">
                {isLoading ? <Loader /> : <HomeAddressForm states={usStates} />}
                {isShowFooterLoader && <Loader footerLoader={true}/>}
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

const mapStateToProps = (state) => ({
  employee: state.employee.details,
  usStates: state.config?.employees?.states,
  isNavigateToNext: state.navigationFromMenu.isNavigateToNext
});

export default connect(mapStateToProps, {
  setEmployeeData: setEmployeeDetails,
})(HomeAddress);
